<template>
  <div id="app">
    <main class="container">
        <div class="d-flex align-items-center bg-dark text-white p-3 my-3  rounded shadow-sm">
        <div class="lh-100">
          <h6 class="mb-0 ">İngilizce Fiiller</h6>
          <small>Erdem AYTEK</small>
        </div>
      </div>
        <!-- <search />   -->
        <Search_Uzak />
        <hr>
        <h5>Kelime Sayacı</h5>

        <Kelime_Sayaci/>
    </main>
   
  </div>
</template>

<script>
// import Search from './components/Search.vue'
import Search_Uzak from './components/Search_Uzak.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Kelime_Sayaci from './components/Kelime_Sayaci.vue'

export default {
  name: 'App',
  components: {
    // Search,
    Search_Uzak,
    Kelime_Sayaci
}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
</style>
